import { render, staticRenderFns } from "./TextareaWithX.vue?vue&type=template&id=e6f47f9a&scoped=true"
import script from "./TextareaWithX.vue?vue&type=script&lang=js"
export * from "./TextareaWithX.vue?vue&type=script&lang=js"
import style0 from "./TextareaWithX.vue?vue&type=style&index=0&id=e6f47f9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f47f9a",
  null
  
)

export default component.exports